import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { smartChargingApiEffects } from './api';
import { reducers } from './smart-charging.reducers';
import { smartChargingStoreSelectorKey } from './smart-charging.state';

@NgModule({
  imports: [
    StoreModule.forFeature(smartChargingStoreSelectorKey, reducers),
    EffectsModule.forFeature([smartChargingApiEffects]),
  ],
  providers: [],
})
export class SmartChargingStoreModule {}
